import { render, staticRenderFns } from "./AuthButtons.vue.html?vue&type=template&id=23aa68ed&scoped=true&external"
import script from "./AuthButtons.vue.js?vue&type=script&lang=js&external"
export * from "./AuthButtons.vue.js?vue&type=script&lang=js&external"
import style0 from "./AuthButtons.vue.scss?vue&type=style&index=0&id=23aa68ed&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23aa68ed",
  null
  
)

export default component.exports